/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*====================================================
=             Delivery Time Calculations (V2)        =
=    Native JS (no Date.js), restored from V1        =
====================================================*/

(function () {
  // Expect the following to be defined by your Liquid snippet on product pages:
  //   window.variantsData         -> { [variantId]: { minDelivery, maxDelivery, productIsAvailable } }
  //   window.initialSelectedId    -> number
  //   window.elemDelivery         -> HTMLElement (container to inject ETA HTML)
  //
  // If any are missing, we no-op safely.

  if (typeof window === 'undefined') return;

  // --- Helpers (native JS; no Date.js needed) ---
  function addDays(date, days) {
    const d = new Date(date.getTime());
    d.setDate(d.getDate() + Number(days || 0));
    return d;
  }

  function isWeekend(date) {
    const day = date.getDay(); // 0=Sun, 6=Sat
    return day === 0 || day === 6;
  }

  function bumpToMondayIfWeekend(date) {
    let d = new Date(date.getTime());
    while (isWeekend(d)) {
      d = addDays(d, 1);
    }
    return d;
  }

  function ordinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  }

  function formatDateMMMDS(date) {
    const month = date.toLocaleString(undefined, { month: 'short' }); // e.g., "Jan"
    const day = date.getDate(); // 1..31
    return `${month} ${day}${ordinal(day)}`;
  }

  function getDateRangeString(variantData) {
    const today = new Date();

    let from = addDays(today, variantData.minDelivery || 0);
    let to   = addDays(today, variantData.maxDelivery || 0);

    // If the landing day is weekend, push to Monday (keeps your V1 intent)
    from = bumpToMondayIfWeekend(from);
    to   = bumpToMondayIfWeekend(to);

    return `${formatDateMMMDS(from)} - ${formatDateMMMDS(to)}`;
  }

  function buildDeliveryHTML(variantId) {
    try {
      const dataMap = window.variantsData;
      if (!dataMap) return '';
      const vd = dataMap[variantId];
      if (!vd) return '';

      // Prefer using a theme asset for the truck icon if you have one:
      const truckUrl = (window.truckIconUrl && typeof window.truckIconUrl === 'string')
      ? window.truckIconUrl
      : 'https://cdn.shopify.com/s/files/1/2692/4812/files/truck.png?8138466027095184927';

      // If you don't have the asset in your theme, keep your existing CDN URL:
      // const truckUrl = "https://cdn.shopify.com/s/files/1/2692/4812/files/truck.png?8138466027095184927";

      const arrives = getDateRangeString(vd);
      const stockText = vd.productIsAvailable
        ? 'In stock, ready to be shipped'
        : 'Dropship (Delivery time depends on Manufacturer&apos;s lead time)';

      const stockClass = vd.productIsAvailable ? 'inventory--high' : 'inventory--low';

      return (
        `<span class="inventory inventory--high">` +
          `<img src="${truckUrl}" style="height:25px;float:left;margin-right:10px;padding-bottom:3px;">` +
          `Arrives between <strong>${arrives}</strong>` +
        `</span>` +
        `<br><span class="inventory ${stockClass}">${stockText}</span>`
      );
    } catch (e) {
      // Fail silently in production
      return '';
    }
  }

  function renderForVariant(variantId) {
    const target = window.elemDelivery;
    if (!target) return;
    const html = buildDeliveryHTML(variantId);
    if (html) target.innerHTML = html;
  }

  // Initial render (after DOM is ready so elem exists)
  document.addEventListener('DOMContentLoaded', function () {
    if (window.elemDelivery && window.initialSelectedId) {
      renderForVariant(window.initialSelectedId);
    }
  });

  // Update on variant change (theme event still the same in v2)
  document.addEventListener('variant:changed', function (event) {
    const variant = event?.detail?.variant;
    if (!variant || !variant.id) return;
    renderForVariant(variant.id);
  }, { passive: true });
})();

/*=====  End of Delivery Time Calculations (V2)  =====*/



/* ---------- COMPAT PATCH: old → new theme ---------- */
(() => {
  // 1) Shopify Product Reviews: set class on successful submit
  // Needed so your CSS rules like `.spr-form-submitted + .spr-reviews` keep working.
  window.SPRCallbacks = window.SPRCallbacks || {};
  window.SPRCallbacks.onFormSuccess = function () {
    const form = document.querySelector('#shopify-product-reviews .spr-form');
    if (form) form.classList.add('spr-form-submitted');
  };

  // 2) Legacy `product:added` expectations
  // Old listeners sometimes expected a `variant` object. New emits { button, quantity, productAdded, variant: null }.
  // We re-emit a legacy-flavored event with a `variant` { id } when we can infer it from the form.
  document.addEventListener('product:added', (e) => {
    try {
      let { button } = e.detail || {};
      let form = button && button.closest ? button.closest('form[action*="/cart/add"]') : null;
      let id = form ? form.querySelector('[name="id"]')?.value : null;
      let variant = id ? { id: parseInt(id, 10) } : null;

      const detail = {
        // keep original fields so new listeners still work
        ...e.detail,
        // add legacy-friendly variant shape
        variant
      };
      document.dispatchEvent(new CustomEvent('product:added:legacy', { bubbles: true, detail }));
    } catch (err) {
      // no-op
    }
  }, { passive: true });

  // 3) (Optional) Adapter for legacy buttons not wrapped in <buy-button>
  // If ALL your add-to-cart buttons are inside <buy-button>, you can delete this block.
  document.addEventListener('click', (evt) => {
    const btn = evt.target.closest?.('[data-action="add-to-cart"]');
    if (!btn) return;

    // If a <buy-button> wrapper exists, let the new component handle it.
    if (btn.closest('buy-button')) return;

    // Legacy fallback: emulate the new buy-button flow (Ajax add).
    const form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    evt.preventDefault();
    evt.stopPropagation();

    btn.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    // Use theme's Form.serialize if available; otherwise serialize locally
    const serialize = (f) => {
      if (window.Form && typeof window.Form.serialize === 'function') return window.Form.serialize(f);
      const fd = new FormData(f);
      const out = {};
      for (const [k, v] of fd.entries()) {
        if (k in out) Array.isArray(out[k]) ? out[k].push(v) : (out[k] = [out[k], v]);
        else out[k] = v;
      }
      return out;
    };

    fetch(`${window.routes.cartAddUrl}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(serialize(form))
    }).then((res) => {
      btn.removeAttribute('disabled');

      const detail = {
        button: btn,
        variant: null, // we’ll add legacy variant via the shim below
        quantity: parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10),
        productAdded: res.ok
      };
      document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail }));

      if (!res.ok) document.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }).catch(() => {
      btn.removeAttribute('disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    });
  });

  // (Nice-to-have) ensure cart refresh on bfcache return still triggers downstream UI updates
  window.onpageshow = window.onpageshow || function () {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  };
})();

// Update price and SKU on variant change
document.addEventListener('variant:changed', function (event) {
  const variant = event?.detail?.variant;
  if (!variant || !variant.id) return;
  
  // Find the price container
  const priceContainer = document.querySelector('.product-form__info-content[role="region"]');
  if (!priceContainer) return;
  
  const priceList = priceContainer.querySelector('.price-list');
  if (!priceList) return;
  
  // Get price and compare_at_price from variant
  const price = variant.price || 0;
  const compareAtPrice = variant.compare_at_price || 0;
  
  // Format prices - try to get currency from Shopify, fallback to USD
  const formatMoney = (cents) => {
    if (!cents || cents === 0) return '$0.00';
    
    const currency = window.Shopify?.currency?.active || 
                     window.Shopify?.shop?.currency || 
                     'USD';
    const locale = window.Shopify?.locale || 'en-US';
    
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  };
  
  // Update the price HTML
  if (price > 0) {
    if (compareAtPrice && compareAtPrice > price) {
      // Sale price with compare at price
      priceList.innerHTML = `
        <span class="price price--highlight">
          <span class="visually-hidden">Sale price</span>
          ${formatMoney(price)}
        </span>
        <span class="price price--compare">
          <span class="visually-hidden">Regular price</span>
          ${formatMoney(compareAtPrice)}
        </span>
      `;
    } else {
      // Regular price only
      priceList.innerHTML = `
        <span class="price">
          <span class="visually-hidden">Price</span>
          ${formatMoney(price)}
        </span>
      `;
    }
  } else {
    // Call for pricing (when price is 0)
    priceList.innerHTML = '<span class="price price--highlight">Call for Pricing</span>';
  }
  
  // Update SKU
  const skuElement = document.querySelector('.product-meta__sku-number');
  if (skuElement) {
    const sku = variant.sku || '';
    skuElement.textContent = sku;
    
    // Show/hide SKU container based on whether SKU exists
    const skuContainer = skuElement.closest('.product-meta__sku');
    if (skuContainer) {
      if (sku) {
        skuContainer.style.display = '';
      } else {
        skuContainer.style.display = 'none';
      }
    }
  }
}, { passive: true });